<ng-container *transloco="let t">
    <div *ngIf="isDesktop">
      <div ngbDropdown #desktopDropdown="ngbDropdown" class="dropdown-small me-2"
        container="body" (openChange)="onDesktopDropdownOpen($event)"
      >
        <div ngbDropdownToggle>
            {{ t(title) }}
        </div>

    <div ngbDropdownMenu class="month-picker p-0 mt-1">
      <div class="dropdown-holder">
        <div class="calendar-holder">
          <ng-container *ngTemplateOutlet="monthPicker"></ng-container>
        </div>

        <button class="btn btn-circle btn-secondary btn-teal btn-sm m-2 float-end"
          (click)="onApply()">
          <i class="bi bi-search"></i>
        </button>
      </div>
    </div>
  </div>
</div>

    <div *ngIf="!isDesktop">
       <div class="dropdown-small" (click)="onOpenMobileFilter()">
            <div class="dropdown-toggle">
                {{ title }}
           </div>
       </div>
    </div>

    <ng-template #offcanvasContent let-offcanvas>
        <div class="sheet-header">
            <div class="d-flex justify-content-between align-items-center ">
                <span class="fs-18 fw-500">{{ title }}</span>
                <button type="button" class="btn-unstyled" aria-label="Close"
                        (click)="onClose()">
                    <img src="assets/img/svg/close-modal.svg" alt="Close modal" style="height: 37px; width: 37px;">
                </button>
            </div>
        </div>
        <div class="sheet-body p-10">
            <ng-container *ngTemplateOutlet="monthPicker"></ng-container>
        </div>
        <div class="sheet-footer">
            <div class="row">
                <div class="col">
                    <app-button-alt [buttonColor]="'white'" [textColor]="'var(--teal-500)'"
                                    [text]="t('app.common.filters.clearAll')" [borderColor]="'var(--teal-500)'"
                                    (onClickCallback)="onClear()" [isFullWidth]="true"
                                    [isDisabled]="false" [buttonHeight]="'44px'" [fontSize]="'14px'"></app-button-alt>
                </div>
                <div class="col">
                    <app-button-alt [text]="t('app.register.to.race.apply')"
                                    (onClickCallback)="onApply()" [isFullWidth]="true"
                                    [isDisabled]="false" [buttonHeight]="'44px'" [fontSize]="'14px'"></app-button-alt>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #monthPicker>
      <div class="month-picker-container">
        <div class="year-selector">
          <button type="button" (click)="prevYear()">‹</button>
            {{ currentYear }}
          <button type="button" (click)="nextYear()">›</button>
    </div>

  <div class="months-grid">
    <button
      *ngFor="let month of months; let i = index"
      class="month-btn"
      [class.in-range]="isInRange(i)"
      [disabled]="monthsDisabled.get(i + 1) ?? true"
      (click)="selectMonth(i)"
    >
    {{ month }}
    </button>
  </div>
</div>
</ng-template>

</ng-container>